angular.module('dnecom')
    .directive('expandableButtonInPanel', ['$uibPosition', '$timeout', function ($position, $timeout) {
        var initialized = false;
        var activeSelector = null;

        return {
            type: 'EA',
            transclude: true,
            replace: true,
            template:
            '<div class="expandable-button-container">'
            + '<button class="btn btn-default" ng-class="{\'active\': isActiveSelector(buttonId)}" ng-click="toggleSelector($event, buttonId)" tooltip-append-to-body="true" uib-tooltip="More actions"><i class="fa fa-bars"></i></button>'
            + '<div class="expandable-btn-group-vertical" style="width:{{ popupWidth || 220 }}px;" ng-show="isActiveSelector(buttonId)" ng-click="onPopupClick($event)" ng-transclude></div>'
            + '</div>',
            scope: {
                buttonId: '=',
                popupWidth: '='
            },
            link: function (scope, element, attrs) {
                if (!initialized) {
                    $(window).click(function () {
                        if (activeSelector) {
                            activeSelector = null;
                            scope.$apply();
                        }
                    });

                    initialized = true;
                }

                scope.timer = null;

                var adjustPopupPosition = function () {
                    var $container = $(element).closest('.btn-group');

                    if ($container[0]) {
                        var popupId = 'expandable-btn-group-vertical-' + scope.buttonId;
                        var $popup = $container.find('#' + popupId);

                        if (!$popup.length) {
                            $popup = $(element).find('.expandable-btn-group-vertical');
                            $popup.attr('id', popupId);
                            $container.append($popup);
                        }

                        $popup.css('left', '-60px');
                        $popup.css('top', '30px');
                        $popup.css('position', 'absolute');
                    }

                    scope.timer = setTimeout(adjustPopupPosition, 1000);
                };

                adjustPopupPosition();

                scope.toggleSelector = function ($event, id) {
                    $event.preventDefault();
                    $event.stopPropagation();

                    if (activeSelector == id) {
                        activeSelector = null;
                    } else {
                        activeSelector = id;
                    }
                };

                scope.isActiveSelector = function (id) {
                    return activeSelector == id;
                };

                scope.onPopupClick = function ($event) {
                    $event.stopPropagation();
                };

                scope.$on('$destroy', function () {
                    if (scope.timer) {
                        clearTimeout(scope.timer);
                    }

                    $('#expandable-btn-group-vertical-' + scope.buttonId).remove();
                });
            }
        }
    }]);
